import React, { useEffect } from 'react';
import SVG from 'react-inlinesvg';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './index.module.scss';

import { ERROR_CODES, PATH } from '#/guest-aps/config';
import { sessionStorageController } from '#/guest-aps/services/storages';

const IN_PROCESS_PATH = [
  PATH.SEARCH_PLATE_NUMBER,
  PATH.SELECT_PLATE_NUMBER,
  PATH.PAYMENT,
  PATH.SELECT_INVOICE,
  PATH.PROMOTION,
] as string[];

interface PageContainerProps {
  style?: React.CSSProperties;
  children: React.ReactNode;
  invertFooter?: boolean;
}

export const PageContainer = ({
  children,
  style,
  invertFooter = false,
}: PageContainerProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // navigate to error page if session storage doesn't have parking lot information
    if (
      IN_PROCESS_PATH.indexOf(location.pathname) !== -1 &&
      !sessionStorageController.getParkinglot()
    ) {
      navigate({
        pathname: PATH.ERROR,
        search: `?code=${ERROR_CODES.NO_SESSION}`,
      });
    }
  }, [navigate, location.pathname]);

  return (
    <div className={styles['page-container']} style={style}>
      <section>{children}</section>
      <footer style={{ color: invertFooter ? '#FFFFFF' : '#999999' }}>
        <SVG
          className="h-[15px] mb-4"
          src="../../assets/ride_with_autopass.svg"
        />
      </footer>
    </div>
  );
};
